import {types} from "mobx-state-tree";

export const variables = types.model({
    college_id: types.optional(types.integer,0),
    user_id: types.optional(types.integer,0),
    nominated: types.optional(types.boolean,false),
    access_token: types.optional(types.string,""),
    refresh_token: types.optional(types.string,""),
    username: types.optional(types.string,""),
    page: types.optional(types.integer,1),
    password: types.optional(types.string,""),    
    e: types.optional(types.integer,0),
}).actions(self=>({
    _college(data){
        self.college_id = data;
    },
    _user(data){
        self.user_id = data;
    },
    _nominated(data){
        self.nominated = data;
    },
    _nominated_count(data){
        self.nominated_count = data;
    },
    _access_token(data){
        self.access_token = data;
    },
    _refresh_token(data){
        self.refresh_token = data;
    },
    _username(data){
        self.username = data;
    },
    _password(data){
        self.password = data;
    },
    _restore(data){
        self.username=data.username;
        self.password=data.password;
    },
    _page(data){
        self.page = data;
    },
    _e(data){
        self.e = data;
    }
}))